__turbopack_context__.v({
  "gradient_canvas": "GradientCanvas-module-sass-module__oC8Rfa__gradient_canvas",
});
